import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eml",
  "use": "icon-eml-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eml\"><path fill=\"#333333\" d=\"M637.952 532.48L512 656.384 386.048 532.48l-317.44 350.208h885.76L637.952 532.48zM28.672 182.272v660.48l317.44-350.208-317.44-310.272z m650.24 310.272l317.44 350.208V182.272l-317.44 310.272zM67.584 141.312L512 576.512l444.416-434.176-888.832-1.024z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol